/**
 * @ngdoc directive
 * @name headerpanel
 *
 * @description
 * Extended header version
 */
module.directive('headerpanel', ['scrolllocker', function (scrolllocker) {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$rootScope', '$scope', '$location', '$document', '$state', 'profile', '$filter', 'headermanager', 'cart', 'lodash', '$window', '$timeout', 'youtubeEmbedUtils', function ($rootScope, $scope, $location, $document, $state, $profile, $filter, $headermanager, $cart, lodash, $window, $timeout, $youtubeEmbedUtils) {
            $scope.isMenuOpen = false;
            $scope.authorization = $profile.authorization;

            $scope.labelClose = $filter('translate')('common.closeMenu');
            $scope.youtubeEmbedUtils = $youtubeEmbedUtils;
            $scope.displayTranslate = false;

            $scope.header = $headermanager;
            $scope.cart = $cart;

            $scope.config = $rootScope.config;

            // account buttons handler
            $scope.signout = function () {
                $scope.waitSignout = true;
                $profile.dismiss().finally(function () {
                    $scope.waitSignout = false;
                    $window.location.href = $state.href('homepage');
                });
            };

            // switch menu visibility
            $scope.toggleMenu = function () {
                $scope.header.toggleMenu(!$scope.header.open);
            };
            $scope.toggleAccountMenu = function () {
                $scope.header.toggleMenu(!$scope.header.openaccount, 'account');
                $scope.instructor = $profile.authorization.role === 'instructor';
            };
            $scope.toggleTranslate = function () {
                $scope.displayTranslate = !$scope.displayTranslate;
                return false;
            }

            // logo
            $scope.logo = {
                text: 'Les Glénans',
                state: 'homepage'
            };

            // test if is current (or parent) menu
            $scope.isCurrent = function (path, item) {
                return $location.path() === path;
            };
            $scope.isCurrentState = function (current) {
                var state = current.parentState || current.state;
                // console.log('isActive', current.label, state);
                return $state.includes(state);
            };

            // sticky socials init
            $window.onresize = function () {
                if ($headermanager.socials) {
                    evalSticky();
                }
            };
            $window.onscroll = function () {
                if ($headermanager.socials) {
                    evalSticky();
                }
            };

            $scope.footerIsVisible = false;
            var evalSticky = lodash.throttle(function () {
                var eFooterSocials = document.getElementsByClassName('aqua-footerpanel--socials')[0];
                if (!eFooterSocials) { return; }

                var coordinates = eFooterSocials.getBoundingClientRect();
                $timeout(function () {
                    $scope.footerIsVisible = (
                        (coordinates.top >= 0 && coordinates.top <= ($window.innerHeight || $document[0].documentElement.clientHeight)) ||
                        (coordinates.bottom >= 0 && coordinates.bottom <= ($window.innerHeight || $document[0].documentElement.clientHeight))
                    );
                }, 0);
            }, 500);

            // specific routing
            $scope.gotoCart = function () {
                $state.go('cart');
            };
            $scope.gotoAccount = function () {
                if ($profile.authorization.authenticated) {
                    $scope.toggleAccountMenu();
                } else {
                    $state.go('login');
                }
            };
            $scope.gotoAdmin = function () {
                if ($profile.authorization.role === 'administrateur') {
                    $window.location.href = './admin/';
                }
            };

            // banner navigation
            $scope.nextBanner = lodash.throttle(function () {
                if ($scope.header.currentBanner < $scope.header.banner.length - 1) {
                    ++$scope.header.currentBanner;
                }
            }, 500);
            $scope.previousBanner = lodash.throttle(function () {
                if ($scope.header.currentBanner > 0) {
                    --$scope.header.currentBanner;
                }
            }, 500);

            // default player params
            $scope.videoParams = {
                controls: 0,
                showinfo: 0,
                modestbranding: 0,
                rel: 0,
                autoplay: 1,
                fs: 0,
                iv_load_policy: 3
            };

            // mute player video when ready
            $scope.$on('youtube.player.ready', function ($event, player) {
                player.mute();
            });
            // force loop
            $scope.$on('youtube.player.ended', function ($event, player) {
                player.playVideo();
            });
        }],
        templateUrl: 'src/components/headerpanel/headerpanel_standard.html'
    };
}]);

/**
 * Header manager factory
 */
module.factory('headermanager', ['profile', '$filter', '$state', 'lodash', 'scrolllocker', 'urls', function ($profile, $filter, $state, lodash, $scrolllocker, urls) {
    'use strict';

    // configuration
    var Header = function () {
        this.id = new Date().getTime();
        this.socials = false;
        this.type = 'standard';
        this.banner = [];
        this.currentBanner = 0;
        this.filled = false;
        this.tunnel = { enabled: false };
        this.mainMenu = [];
        this.secondaryMenu = [];
        this.accountMenu = { label: '', state: 'member.home', profile: $profile.authorization, info: $profile.info };
        this.cartMenu = { label: '', url: '/' + urls.cart.fr, title: '' }; // TODO : when multilang, change this to something dynamic
    };

    Header.prototype.setMenus = function (primary, secondary) {
        var normalize = function (menu) {
            return lodash.chain(menu).toArray().initial(function (m) {
                return lodash.isObject(m);
            }).value();
        };
        primary.forEach(function (menu) {
            this.mainMenu.push({
                label: menu.title,
                url: menu.url,
                submenu: normalize(menu.children_links)
            });
        }, this);

        angular.merge(this.secondaryMenu, normalize(secondary));
    };
    Header.prototype.setLanguage = function () {
        // console.log({ roles: $profile.roles, authorization: $profile.authorization });
        this.accountMenu.label = $filter('translate')('common.account');
        this.accountMenu.submenu = [
            { label: $filter('translate')('account.myHome'), state: 'member.home' },
            { label: $filter('translate')('account.myAccountInfo'), state: 'member.info.profil', parentState: 'member.info' },
            { label: $filter('translate')('account.myOrders'), state: 'member.orders.list' },
            { label: $filter('translate')('account.myTrainings'), state: 'member.training.profil', parentState: 'member.training' },
            { label: $filter('translate')('account.mySupervision'), state: 'member.supervision.list', parentState: 'member.supervision', limited: $profile.roles.instructor },
            { label: $filter('translate')('account.myRtq'), state: 'member.rtq.list', parentState: 'member.rtq', limited: !$profile.authorization.rtq },
            { label: $filter('translate')('account.myAssessments'), state: 'member.assessments.list', parentState: 'member.assessments', limited: $profile.roles.instructor },
            { label: $filter('translate')('account.myMembership'), state: 'member.membership.list' }
        ];
        this.cartMenu.label = $filter('translate')('common.cart');
        this.cartMenu.title = $filter('translate')('common.cartLegend');
    };
    Header.prototype.toggleMenu = function (state, menu) {
        if (menu === 'account') {
            this.openaccount = state;
            this.open = false;
        } else {
            this.openaccount = false;
            this.open = state;
        }
        if (state) {
            $scrolllocker.lock();
        } else {
            $scrolllocker.unlock();
        }
    };
    Header.prototype.customize = function (options) {
        this.socials = options.socials ? true : false;
        if (lodash.isArray(options.picture)) {
            this.banner = options.picture;
        } else if (lodash.isObject(options.picture)) {
            this.banner = [options.picture];
        } else {
            this.banner = [];
        }
        this.currentBanner = 0; // reset slider position
        // this.banner = options.picture ? 'url(' + options.picture + ')' : 'none';
        this.type = options.type || 'standard';
        this.filled = options.filled;
        this.tunnel = options.tunnel ? lodash.merge(options.tunnel, { enabled: true }) : { enabled: false };
    };
    Header.prototype.setAccountConfiguration = function (params) {
        this.accountMenu.submenu = params.menu || [];
    };

    return new Header();
}]);
